import { constants } from '@saucelabs/sl-module-organization';

import { SHOW_MULTIPLE_TEAMS_FEATURE } from './constants';

export const toggleSetValue = (item, value) => (
  item.has(value) ? item.remove(value) : item.add(value)
);

export const modify = (state, key, callback) => {
  const path = Array.isArray(key) ? key : [key];
  return state.setIn(path, callback(state.getIn(path)));
};

export const isValidSsoXml = (xmlFile) => (
  new RegExp(constants.ENTITY_ID_RE).test(xmlFile) &&
  new RegExp(constants.X509CERTIFICATE_RE).test(xmlFile)
);

export const haveAccessToMultipleTeams = (user) => {
  const isGlobal = user.get('organization', {})?.is_global || false;
  return isGlobal && SHOW_MULTIPLE_TEAMS_FEATURE;
};
